// Ícones desenhados no traço do kit (tinta, pontas redondas, leve irregularidade),
// no lugar de glifos unicode. Herdam a cor do texto (currentColor).
import type { SVGProps } from 'react';

export type IconName =
  | 'regions'
  | 'log'
  | 'rules'
  | 'menu'
  | 'undo'
  | 'zoomIn'
  | 'zoomOut'
  | 'fit'
  | 'close'
  | 'hourglass'
  | 'chevronUp'
  | 'chevronDown'
  | 'warning'
  | 'sword'
  | 'shield'
  | 'crown'
  | 'scroll'
  | 'flag'
  | 'skull';

const PATHS: Record<IconName, JSX.Element> = {
  regions: (
    <>
      <path d="M2.5 19.5 L8.6 9.2 L11.6 13.6 L14.4 8 L21.5 19.5 Z" />
      <path d="M12.9 11 L14.4 8 L16.1 11.1 L15 10.5 L14.2 11.6 L13.6 10.6 Z" fill="currentColor" stroke="none" />
      <path d="M7.4 11.2 L8.6 9.2 L9.9 11.2" />
    </>
  ),
  log: (
    <>
      <path d="M5 4.5 C9 4 12 4.4 12 6.2 V20 C12 18.6 9 18.2 5 18.6 Z" />
      <path d="M19 4.5 C15 4 12 4.4 12 6.2 V20 C12 18.6 15 18.2 19 18.6 Z" />
      <path d="M7.2 8.4 H10 M7.2 11.2 H10 M14 8.4 H16.8 M14 11.2 H16.6 M14 14 H16" />
    </>
  ),
  rules: (
    <>
      <path d="M6.5 4 H17 C18.6 4 19.2 5.6 18.2 6.6 H8" />
      <path d="M8 6.6 V18.5 C8 20 6.4 20.6 5.4 19.6 C4.6 18.8 5 17.4 6.2 17.4 H15.8" />
      <path d="M17.2 6.6 V17.4" />
      <path d="M10.4 10 H15 M10.4 13 H14.2" />
    </>
  ),
  menu: <path d="M4.5 6.8 C9 6.2 15 7.2 19.5 6.6 M4.5 12.2 C9 11.7 15 12.6 19.5 12 M4.5 17.6 C9 17 15 18 19.5 17.4" />,
  undo: (
    <>
      <path d="M8.5 6 L4.5 10 L8.5 14" />
      <path d="M4.8 10 H14 C17.5 10 19.6 12.4 19.6 15.2 C19.6 17.6 17.8 19.4 15 19.4 H11" />
    </>
  ),
  zoomIn: (
    <>
      <circle cx="10.5" cy="10.5" r="6" />
      <path d="M15 15 L20 20 M8 10.5 H13 M10.5 8 V13" />
    </>
  ),
  zoomOut: (
    <>
      <circle cx="10.5" cy="10.5" r="6" />
      <path d="M15 15 L20 20 M8 10.5 H13" />
    </>
  ),
  fit: <path d="M4 9 V4.5 H8.6 M15.4 4.5 H20 V9 M20 15 V19.5 H15.4 M8.6 19.5 H4 V15 M9 12 H15 M12 9 V15" />,
  close: <path d="M6 6.2 C9 9.4 14.6 14.4 18 17.8 M18 6 C14.8 9 9.4 14.8 6.2 18" />,
  hourglass: (
    <>
      <path d="M6.5 3.5 H17.5 M6.5 20.5 H17.5" />
      <path d="M8 3.5 C8 8 11 9.6 11 12 C11 14.4 8 16 8 20.5 M16 3.5 C16 8 13 9.6 13 12 C13 14.4 16 16 16 20.5" />
      <path d="M9.6 18.6 C10.6 16.6 13.4 16.6 14.4 18.6 Z" fill="currentColor" />
    </>
  ),
  chevronUp: <path d="M6 14.5 L12 8.8 L18 14.5" />,
  chevronDown: <path d="M6 9.5 L12 15.2 L18 9.5" />,
  warning: (
    <>
      <path d="M12 3.8 L21 19.6 H3 Z" />
      <path d="M12 9.6 V14 M12 16.8 V17" />
    </>
  ),
  sword: (
    <>
      <path d="M19.5 4.5 L9 15 M19.5 4.5 L16 5 M19.5 4.5 L19 8" />
      <path d="M6.4 12.4 L11.6 17.6 M8 16 L4.4 19.6" />
    </>
  ),
  shield: <path d="M12 3.5 C14.6 5 17 5.6 19.5 5.6 C19.5 13 17 17.6 12 20.5 C7 17.6 4.5 13 4.5 5.6 C7 5.6 9.4 5 12 3.5 Z" />,
  crown: <path d="M4 17.5 L3.4 7.6 L8.4 11.6 L12 5 L15.6 11.6 L20.6 7.6 L20 17.5 Z M4.4 20 H19.6" />,
  scroll: (
    <>
      <path d="M7 4.5 H18 C19.4 4.5 19.8 6.4 18.6 7 H9" />
      <path d="M9 7 V17.4 C9 19 7.6 19.6 6.4 19 C5.2 18.4 5.4 16.6 6.6 16.6 H16.6 V7" />
    </>
  ),
  flag: (
    <>
      <path d="M6 21 V3.5" />
      <path d="M6 4.5 C9 3 12 6.4 18.5 4.8 L16.4 9 L18.5 13 C12 14.6 9 11.4 6 12.8" />
    </>
  ),
  skull: (
    <>
      <path d="M12 3.6 C7.4 3.6 4.8 6.8 5 10.4 C5.1 12.6 6.2 13.8 7.4 14.6 V18 H16.6 V14.6 C17.8 13.8 18.9 12.6 19 10.4 C19.2 6.8 16.6 3.6 12 3.6 Z" />
      <circle cx="9.3" cy="10.4" r="1.6" fill="currentColor" />
      <circle cx="14.7" cy="10.4" r="1.6" fill="currentColor" />
      <path d="M10.2 18 V20.4 M13.8 18 V20.4" />
    </>
  ),
};

export function Icon({ name, size = 18, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
      className="icon"
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}
